<template>
  <div>
    <div id="_div" class="w-100 px-5 py-4">
      <div id="Titulo_div">
        <h1>Información de Notificación de Cita</h1>

      </div>
      <div style="display: flex">
        <div class="col-12 padding-div-low">
          <div class="area" v-if="bitacoraDeCorreo!=null">
            <div class="row">
              <div class="col-4 border-right">
                <div class="row"><h4>Datos de Notificación</h4></div>
                <div class="row"><b>Fecha y Hora: </b><span>{{bitacoraDeCorreo.FechaDeEnvioString}}</span></div>
                <div class="row"><b>Remitente: </b><span></span></div>
                <div class="row"><b>Destinatario: </b><span>{{bitacoraDeCorreo.Cita.InformacionDeSolicitante.CorreoElectronico}}</span></div>
              </div>
              
              <div class="col-8" >
                
                <p v-html="bitacoraDeCorreo.CuerpoDelCorreo" class="cuerpoCorreo">
                  </p>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import catalogos from '@/../static/js/catalogos'
  import api from '@/../static/js/api'
  import comun from '@/../static/js/comun'
  import axios from 'axios'
  import store from '@/store/index'
  export default {
    props: ['citaId'],
    data() {
      return {
        bitacoraDeCorreo: null
      }
    },
    components: {
    },
    methods: {
      cargarInfoNotificacionCita: function () { //Carga la información de BD de una cita.
        var peticion = {
          "esPrueba": false,
          "CitaId": this.citaId
        };
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SICCIJ.funciones.GetInformacionNotificacionCita, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {//En caso de que la petición sea exitosa
            this.bitacoraDeCorreo = response.data.BitacoraDeCorreo
            this.bitacoraDeCorreo.CuerpoDelCorreo = this.bitacoraDeCorreo.CuerpoDelCorreo.replace("\n","<br>")
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });
      },
      volverSeguimientoCitas: function () { //Redirige a la página 'SeguimientoDeCitas'.
        //alert('volver')
        this.$router.push({
          name: 'SeguimientoDeCitas'
        })
        return;
      },
    }, mounted: function mounted() {
      this.cargarInfoNotificacionCita();
    }, computed: {
    }
  }
</script>
<style scoped>
  .padding-div-low {
    padding-top: 40px;
  }
  .fas {
    cursor: pointer;
  }
  span {
    margin-bottom: 5px;
    margin-left: 5px;
  }
  .cuerpoCorreo {
    overflow-wrap: normal;
  }
</style>



// WEBPACK FOOTER //
// src/components/SICCIJ/Recepcion/SeguimientoDeCitas/InformacionDeNotificacionCita.vue